import { Stack, InputAdornment, TextField } from '@mui/material';
import Iconify from 'src/components/Iconify';
// components
import useLocales from 'src/hooks/useLocales';

// ----------------------------------------------------------------------

type Props = {
  searchBy: string;
  onsearchBy: (value: string) => void;
};

export default function BlockTableToolbar({ searchBy, onsearchBy }: Props) {
  const { translate } = useLocales();
  return (
    <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} sx={{ py: 2.5, px: 3 }}>
      <TextField
        fullWidth
        value={searchBy}
        onChange={(event) => onsearchBy(event.target.value)}
        placeholder={translate('contractsInfo.Placeholder')}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify
                icon={'eva:search-fill'}
                sx={{ color: 'text.disabled', width: 20, height: 20 }}
              />
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
}
